
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export default function SidePanelRoot({
  isOpen,
  options,
  onBackdrop,
  onClose,
  children,
}) {
  const panelRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    if (isOpen) document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen && panelRef.current) {
      const focusable = panelRef.current.querySelector(
          'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]'
      );
      focusable?.focus();
    }
  }, [isOpen]);

  const {
    width = '50%',
    position = 'right',
    ariaLabel = 'Side panel',
    panelClassName = '',
    backdropClassName = '',
  } = options || {};

  const portalContent = (
    <div aria-hidden={!isOpen} role="dialog" aria-modal="true" aria-label={ariaLabel}>
      <div
        className={`sp-backdrop ${isOpen ? 'sp-backdrop--visible' : ''} ${backdropClassName}`}
        onClick={isOpen ? onBackdrop : undefined}
      />

      <aside
        ref={panelRef}
        className={`sp-panel sp-panel--${position} ${isOpen ? 'sp-panel--open' : ''} ${panelClassName}`}
        style={{ width }}
      >
        {children}
      </aside>
    </div>
  );
  if (!isOpen) return null;
  return createPortal(portalContent, document.body);
}
